interface Props {
	words: string;
	description?: string;
	children?: React.ReactNode;
}

const Title = ({ words, description, children }: Props) => {
	return (
		<div className="flex flex-col mx-auto mb-4 px-4 w-full max-w-lg">
			<h1 className="flex justify-center items-center m-auto w-10/12 font-bold dark:text-slate-50 text-3xl text-center leading-12">
				{words}
			</h1>
			{description && (
				<p className="mt-4 text-slate-700 dark:text-slate-300 text-lg text-center">
					{description}
				</p>
			)}
			{children}
		</div>
	);
};

export default Title;
